import { useContext } from 'react';
import { TabContext } from '../../../Context/TabContext';
import './Tab.css';
import { useTranslation } from 'react-i18next';

function Tab(props) {
  const { t, i18n } = useTranslation();
  const tabContext = useContext(TabContext);
  const { tab, style, deleteStyle } = props;
  const tabStyle = [tab.icon, 'tab_icon'].join(' ');

  const onWheelClick = (e) => {
    if (e.button === 1) {
      const tabs = JSON.parse(localStorage.getItem('tabs'));
      console.log(tabs);
      if (tab.type === tabs[0].type) {
        return;
      }
      tabContext.deleteTab(tab);
    }
  };

  return (
    <div className="tab" onMouseDown={onWheelClick}>
      <span
        onClick={() => tabContext.setActive(tab)}
        className={style.join(' ')}
      >
        {tab.icon && <i className={tabStyle} />}
        {t(`menuItem.${tab.title}`).includes('menuItem')
          ? tab.title
          : t(`menuItem.${tab.title}`)}
      </span>
      <span
        className={deleteStyle.join(' ')}
        onClick={() => tabContext.deleteTab(tab)}
      >
        <i className="fas fa-times" />
      </span>
    </div>
  );
}

export default Tab;
